import { PageTitle } from 'app/components/common/PageTitle'
import DegreeManagementContainer from 'app/containers/DegreeManagement'
import { isEqual } from 'lodash'
import { memo } from 'react'

const DegreeManagementCpn = () => {
  return (
    <>
      <PageTitle>{'Quản lý học vị'}</PageTitle>
      <DegreeManagementContainer />
    </>
  )
}
export const DegreeManagementPage = memo(DegreeManagementCpn, isEqual)
